import React, { useCallback } from 'react'

import { Button } from '@gousto-internal/citrus-react'
import classnames from 'classnames'

import { isMobile } from 'utils/view'

import css from './BrowseCTAButton.css'

const BUTTON_CLASSES = {
  mobile: css['setDeliveryDateButton-mobile'],
  desktop: css['setDeliveryDateButton-desktop'],
  '': '',
}

const handleSetDeliveryDateClick = (
  menuBrowseCTAVisibilityChange: (show: boolean) => void,
  boxDetailsVisibilityChange: (show: boolean, totalPrice?: string) => void,
  boxSummaryShow: boolean,
) => {
  if (!boxSummaryShow) {
    menuBrowseCTAVisibilityChange(false)
    boxDetailsVisibilityChange(true)
  } else {
    boxDetailsVisibilityChange(false)
  }
}

type BrowseCTAButtonProps = {
  boxDetailsVisibilityChange: (show: boolean, totalPrice?: string) => void
  boxSummaryShow?: boolean
  disable: boolean
  fullWidth?: boolean
  menuBrowseCTAVisibilityChange: (show: boolean) => void
  view: 'mobile' | 'desktop' | ''
}

const BrowseCTAButton = ({
  boxDetailsVisibilityChange,
  boxSummaryShow = true,
  disable,
  fullWidth = false,
  menuBrowseCTAVisibilityChange,
  view,
}: BrowseCTAButtonProps) => {
  const isMobileView = isMobile(view)
  const classes = classnames(BUTTON_CLASSES[view], {
    [css.fullWidth]: isMobileView && fullWidth,
  })

  const onClick = useCallback(() => {
    if (!disable) {
      handleSetDeliveryDateClick(
        menuBrowseCTAVisibilityChange,
        boxDetailsVisibilityChange,
        boxSummaryShow,
      )
    }
  }, [boxDetailsVisibilityChange, boxSummaryShow, disable, menuBrowseCTAVisibilityChange])

  return (
    <Button className={classes} data-testing="menuBrowseCTAButton" onClick={onClick}>
      Set Delivery Date
    </Button>
  )
}

export { BrowseCTAButton }
